'use client'

import { FC } from 'react'
import { testIds } from '@/root/shared-consts'
import { useGetTranslations } from '@/root/shared-hooks'
import { getStyledHTML } from '@/root/utils/getStyledHTML'
import { tuuleliinid } from '@/root/shared-consts/theme'
import { Checkbox } from '@/root/ui/tuuleliinid'
import cn from 'classnames'

interface TermsAndConditionsProps {
  isAgree: boolean
  onAgree(): void
  terms?: string
}

export const TermsAndConditions: FC<TermsAndConditionsProps> = ({ onAgree, isAgree, terms }) => {
  const { getTranslation } = useGetTranslations()
  const styledTerms = terms ? (getStyledHTML({ theme: tuuleliinid, body: terms }) ?? '') : ''

  return (
    <div
      data-testid={testIds.confirm.paymentTerms}
      className={cn(
        'flex w-full items-center gap-2.5 rounded-lg border p-4',
        isAgree ? 'border-success bg-success-very-light' : 'bg-warning-very-light border-warning-dark'
      )}
    >
      {/* Confirm checkbox */}
      <div>
        <Checkbox
          className="text-neutral-darker mb-2 gap-2 uppercase"
          variant="success"
          label={`${getTranslation('confirmationTermsAndConditionsTermsQuestions')}:`}
          checked={isAgree}
          onChange={onAgree}
          testId={testIds.confirm.paymentTermsCheckbox}
        />
        <div
          className={cn(
            'flex flex-col items-start gap-3 text-base font-normal',
            isAgree ? 'text-success-dark' : 'text-warning-dark'
          )}
          dangerouslySetInnerHTML={{ __html: styledTerms }}
        />
      </div>
    </div>
  )
}
